@if (!isAuthRoute()) {
    <mat-toolbar class="topbar" [class.run-mode]="isSurveyRunRoute()" color="primary">
        @if (isSurveyRunRoute()) {
            <span class="brand-lockup align-center">
                <img class="brand-logo align-center" src="/assets/npd-sensorix.png" alt="NPD Sensorix" />
                @if (titleSuffix()) {
                    <span class="brand-page-title align-center">
                        <span class="brand-rest align-center">{{ titleSuffix() }}</span>
                    </span>
                }
            </span>
        } @else {
            <div class="topbar-left flex-row align-center justify-center">
                <button class="burger-btn" mat-icon-button (click)="toggleSidebar()" aria-label="Меню">
                    <mat-icon>menu</mat-icon>
                </button>
            </div>

            <span class="brand-lockup brand-link align-center" (click)="goDashboard()" style="cursor: pointer">
                <img class="brand-logo align-center" src="/assets/npd-sensorix.png" alt="NPD Sensorix" />
                @if (titleSuffix()) {
                    <span class="brand-page-title align-center">
                        <span class="brand-rest align-center">{{ titleSuffix() }}</span>
                    </span>
                }
            </span>

            <span class="spacer"></span>

            <div class="topbar-actions flex-row align-center">
                <button
                    mat-icon-button
                    type="button"
                    (click)="toggleTheme()"
                    [matTooltip]="themeService.isDark() ? 'Светлая тема' : 'Тёмная тема'"
                    [attr.aria-label]="themeService.isDark() ? 'Светлая тема' : 'Тёмная тема'"
                    data-testid="theme-toggle"
                >
                    <mat-icon>{{ themeService.isDark() ? 'light_mode' : 'dark_mode' }}</mat-icon>
                </button>

                @if (isAdmin() && companies().length) {
                    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="company-field">
                        <mat-label>Активная компания</mat-label>
                        <mat-select [value]="adminCompanyContextService.companyId()" (selectionChange)="onCompanyChange($event.value)">
                            @for (company of companies(); track company.id) {
                                <mat-option [value]="company.id">{{ company.name }}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                }

                @if (toolbar.showCreate()) {
                    <button mat-raised-button color="accent" (click)="logout()">
                        <mat-icon>logout</mat-icon>
                        <span class="hide_mobile">Выход</span>
                    </button>
                }
            </div>
        }
    </mat-toolbar>
}

<div class="shell-layout flex-row flex-1" [class.with-sidebar]="showSidebar()">
    @if (showSidebar()) {
        <aside class="sidebar flex-column align-center" [class.expanded]="isSidebarExpanded()">
            @for (item of navItems; track item.routePrefix) {
                <button
                    class="sidebar-item flex-row align-center justify-center w100"
                    [class.active]="isActiveRoute(item.routePrefix)"
                    (click)="item.action()"
                    [attr.aria-label]="item.label"
                >
                    <mat-icon [matTooltip]="item.label">{{ item.icon }}</mat-icon>
                    @if (isSidebarExpanded()) {
                        <span class="label">{{ item.label }}</span>
                    }
                </button>
            }

            @if (currentUserService.isAdmin()) {
                <button
                    class="sidebar-item flex-row align-center justify-center w100"
                    [class.active]="isActiveRoute('/companies-list')"
                    (click)="goCompanies()"
                    aria-label="Компании"
                >
                    <mat-icon matTooltip="Компании">business</mat-icon>
                    @if (isSidebarExpanded()) {
                        <span class="label">Компании</span>
                    }
                </button>
            }
        </aside>
    }

    <div class="content scroll-auto h-100 flex-1">
        <router-outlet></router-outlet>
    </div>
</div>
